/*global google*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import Message from '../Common/Message/Message';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './Videos.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Videos extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            message: {
                title: '',
                content: '',
                type: '',
            },
            videos: [],
        };
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    componentDidMount = () => {
        this.getAdminVideos();
    }

    handleVideoChange = (e: Object, index: number, attribute: string) => {
        const videos = this.state.videos;
        videos[index][attribute] = e.target.value;
        this.setState({
            videos,
        });
    };

    getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = this.state.videos;
                    videosResponse.data.forEach((video) => {
                        videos.push(video);
                    });
                    videos.forEach((video) => {
                        video.isNew = false;
                    });
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }

    addVideo = () => {
        const videos = this.state.videos;
        let newVideo = {};
        newVideo.title = '';
        newVideo.youtube_id = '';
        videos.push(newVideo);
        this.setState({
            videos,
        });
    };

    handleSave = () => {
        this.setMessage('', '', 'loading');
        const videos = this.state.videos;
        videos.forEach((video) => {
            this.saveUpdateVideo(video);
        });
    };

    saveUpdateVideo = async (video: Object) => {
        const saveResponse = await saveVideo();
        console.log('saveResponse: ', saveResponse);
        if (saveResponse.data) {
            this.setMessage(window.general_strings.msg.yay, '', 'success');
        } else {
            this.setMessage(window.general_strings.msg.oops, '', 'error');
        }

        async function saveVideo() {
            let query = video.id ? `/admin/videos/${video.id}` : `/admin/videos`;
            let method = video.id ? `PUT` : `POST`;
            let data = {};
            data.title = video.title;
            data.youtube_id = video.youtube_id;
            return await ApiRequest(query, {
                method,
                data,
            });
        } 
    }

    renderVideos = () => {
        const videos = this.state.videos;
        return (
            <React.Fragment>
                {videos.map((video, index) => (
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label>{strings.videoTitle}</label>
                                <input 
                                    className="showtix-input" 
                                    type="text" 
                                    value={video.title} 
                                    onChange={(e) =>
                                        this.handleVideoChange(
                                            e,
                                            index,
                                            'title',
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <div className="showtix-form__input">
                                    <label>{strings.youtubeId}</label>
                                    <input 
                                        className="showtix-input" 
                                        type="text" 
                                        value={video.youtube_id} 
                                        onChange={(e) =>
                                            this.handleVideoChange(
                                                e,
                                                index,
                                                'youtube_id',
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </React.Fragment>
        );
    };

    render() {
        return (
            <div className="showtix-section">
                <Message
                    message={this.state.message}
                />
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>{strings.title}</h1>
                            <p>{strings.description}</p>
                            {this.renderVideos()}
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <button
                                            className="showtix-button showtix-background__primary-3"
                                            onClick={this.addVideo}
                                        >
                                            {strings.addVideo}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <button
                                            type="button"
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={this.handleSave}
                                        >
                                            <span>{strings.save}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Videos.propTypes = {
}

export default Videos;



// WEBPACK FOOTER //
// ./src/components/Videos/Videos.js